import { SECTION_ACCESS_TYPES } from '../utils/consts';

export const isViewMode = (partnerConfiguration, isAgency, isPartner, accessType) =>
    partnerConfiguration?.isCustom ||
    isPartner ||
    (isAgency && accessType === SECTION_ACCESS_TYPES.VIEW);
